export const toastCopyFr = {
    saved: "Enregistré",
    savedForNow: "Enregistré pour le moment.",
    savedSuccessfully: "Enregistré avec succès",
    errorSaving: "Erreur lors de l'enregistrement",
    errorSavingTracker: "Erreur lors de l'enregistrement du suivi",
    updateFailed: "Échec de la mise à jour",
    errorUpdating: "Erreur lors de la mise à jour",
    errorCreating: "Erreur lors de la création",
    errorCreatingInput: "Erreur lors de la création du champ",
    errorCreatingDiaryLog: "Erreur lors de la création de l'entrée du journal",
    errorCreatingEvent: "Erreur lors de la création de l'événement",
    errorUpdatingEvent: "Erreur lors de la mise à jour de l'événement",
    errorUpdatingProfile: "Erreur lors de la mise à jour du profil, veuillez réessayer",
    errorWhileUploading: "Erreur lors de l'envoi",
    refreshAndRetry: "Erreur, veuillez actualiser la page et réessayer",
    noDataReturned: "Aucune donnée renvoyée",
    settingsSaved: "Paramètres enregistrés",
    copiedToClipboard: "Copié dans le presse-papiers",
    linkCopiedToClipboard: "Lien copié dans le presse-papiers",
    pleaseSelectFile: "Veuillez sélectionner un fichier",
    pasteImageFromClipboard: "Collez une image depuis votre presse-papiers (Ctrl+V ou Cmd+V)",
    loggedOutSuccess: "Déconnexion réussie",
    loggingIn: "Connexion en cours",
    errorLoggingIn: "Erreur de connexion",
    loginSuccessful: "Connexion réussie",
    signUpSuccessful: "Inscription réussie",
    transferRequested: "Transfert demandé - veuillez vérifier votre e-mail pour vous assurer qu'il a bien abouti.",
    organisationAdded: "Organisation ajoutée",
    organisationAlreadyAdded: "Organisation déjà ajoutée",
    deletionRequestSent: "Demande de suppression envoyée",
    userAuthenticated: "Utilisateur authentifié",
    codeIncorrect: "Code incorrect",
    codeCorrect: "Code correct",
    errorSigningIn: "Erreur de connexion",
    otpFailedToSend: "Échec de l'envoi du mot de passe à usage unique",
    passwordUpdatedSuccess: "Mot de passe mis à jour avec succès !",
    emailOrPasswordIncorrect: "E-mail ou mot de passe incorrect",
    phoneNumberConfirmed: "Numéro de téléphone confirmé",
    errorConfirmingPhoneNumber: "Erreur lors de la confirmation du numéro de téléphone",
    profileUpdatedSuccess: "Profil mis à jour avec succès",
    professionalDetailsSaved: "Informations professionnelles enregistrées !",
    failedUpdateProfessionalDetails: "Échec de la mise à jour des informations professionnelles",
    templateCreatedSuccess: "Modèle créé avec succès !",
    templatesCreatedSuccess: (count) =>
        count === 1 ? "Modèle créé avec succès !" : `${count} modèles créés avec succès !`,
    failedCreateTemplate: "Échec de la création du modèle",
    templateUpdatedSuccess: "Modèle mis à jour avec succès",
    failedUpdateTemplate: "Échec de la mise à jour du modèle",
    templateDeletedSuccess: "Modèle supprimé avec succès",
    failedDeleteTemplate: "Échec de la suppression du modèle",
    templateDuplicatedSuccess: "Modèle dupliqué avec succès",
    failedDuplicateTemplate: "Échec de la duplication du modèle",
    templateSharedSuccess: "Modèle partagé avec succès",
    errorSharingTemplate: (message) => `Erreur lors du partage du modèle : ${message}`,
    analyticsViewSharedSuccess: "Vue partagée avec succès",
    errorSharingAnalyticsView: (message) => `Erreur lors du partage de la vue : ${message}`,
    analyticsViewUnsharedSuccess: "Vue partagée supprimée",
    errorUnsharingAnalyticsView: (message) => `Erreur lors de la suppression de la vue partagée : ${message}`,
    trackerSaved: "Suivi enregistré",
    entryUpdatedSuccess: "Saisie mise à jour avec succès",
    entrySaved: "Saisie enregistrée",
    entryDeleted: "Saisie supprimée",
    entryTimingUpdated: "Échéance de la saisie mise à jour",
    scheduleUpdated: "Calendrier mis à jour",
    entryRemovedFromSchedule: "Saisie retirée du calendrier",
    entryAssignedToScheduleStep: "Saisie affectée à une étape du calendrier",
    stepAlreadyOccupied: "Cette étape comporte déjà une saisie.",
    diaryUpdatedSuccess: "Journal mis à jour avec succès",
    diaryInputsAddedSuccess: "Champs du journal ajoutés avec succès",
    diaryDiscardedSuccess: "Journal abandonné avec succès",
    diaryReinstatedSuccess: "Journal réactivé avec succès",
    diaryDischargedSuccess: "Journal clôturé avec succès",
    diaryEnded: "Journal clôturé",
    labelCreated: "Étiquette créée",
    labelUpdated: "Étiquette mise à jour",
    labelDeleted: "Étiquette supprimée",
    labelsUpdated: "Étiquettes mises à jour",
    tableSettingsSaved: "Paramètres du tableau enregistrés",
    detailsSaved: "Vos informations ont été enregistrées.",
    hospitalNumberRequired: "Le numéro de dossier hospitalier est obligatoire",
    couldNotSaveHospitalNumber: "Impossible d'enregistrer le numéro de dossier hospitalier",
    sharedAttributesUpdated: "Attributs partagés mis à jour",
    errorUpdatingSharedAttributes: "Erreur lors de la mise à jour des attributs partagés",
    sharedAttributesCreated: "Attributs partagés créés",
    errorCreatingSharedAttributes: "Erreur lors de la création des attributs partagés",
    diaryAccessSaved: "Accès au journal enregistré",
    failedSaveDiaryAccess: "Échec de l'enregistrement de l'accès au journal",
    joinedDateGroupSuccess: "Groupe de dates rejoint avec succès",
    failedJoinDateGroup: (message) => `Échec de l'adhésion au groupe de dates : ${message}`,
    questionnaireStopped: "Questionnaire arrêté",
    errorStoppingQuestionnaire: "Erreur lors de l'arrêt du questionnaire",
    consentAddedToDiary: "Consentement ajouté au journal",
    errorAddingConsentToDiary: "Impossible d'ajouter le consentement",
    eventSaved: "Événement enregistré",
    eventUpdated: "Événement mis à jour",
    eventDeletedSuccess: "Événement supprimé avec succès",
    eventTrackerLinked: "Événement et suivi associés",
    errorLinkingEventTracker: (message) => `Erreur lors de l'association de l'événement et du suivi. ${message}`,
    surgerySaved: "Opération enregistrée",
    errorCreatingSurgery: "Erreur lors de la création de la nouvelle opération",
    surgeryOptionUpdated: "Option d'opération mise à jour",
    errorUpdatingSurgeryOption: "Erreur lors de la mise à jour de l'option d'opération",
    newSurgeryOptionSaved: "Nouvelle option d'opération enregistrée",
    consultationSaved: "Consultation enregistrée",
    errorCreatingConsultation: "Erreur lors de la création de la nouvelle consultation",
    errorUpdatingConsultation: "Erreur lors de la mise à jour de la consultation",
    imagingRequestSaved: "Demande d'imagerie enregistrée",
    errorCreatingImagingRequest: "Erreur lors de la création de la demande d'imagerie",
    injectionDetailsUpdated: "Informations sur l'injection mises à jour",
    errorUpdatingInjectionDetails: "Erreur lors de la mise à jour des informations sur l'injection",
    injectionDiaryDefaultSaved: "Valeur par défaut du journal d'injection enregistrée",
    errorSavingInjectionDiaryDefault: "Erreur lors de l'enregistrement de la valeur par défaut du journal d'injection",
    diaryInjectionAdded: "Injection ajoutée au journal",
    errorCreatingDiaryInjection: "Erreur lors de la création de l'injection du journal",
    injectionContentUpdated: "Contenu de l'injection mis à jour",
    failedUpdateInjectionContent: "Échec de la mise à jour du contenu de l'injection",
    injectionContentDeleted: "Contenu de l'injection supprimé",
    failedDeleteInjectionContent: "Échec de la suppression du contenu de l'injection",
    publicStatusUpdated: "Statut public mis à jour",
    failedUpdatePublicStatus: "Échec de la mise à jour du statut public",
    injectionLocationUpdated: "Site d'injection mis à jour",
    failedUpdateInjectionLocation: "Échec de la mise à jour du site d'injection",
    newInjectionLocationCreated: "Nouveau site d'injection créé",
    failedCreateInjectionLocation: "Échec de la création du site d'injection",
    newInjectionContentsCreated: "Nouveaux contenus d'injection créés",
    failedCreateInjectionContents: "Échec de la création des contenus d'injection",
    failedSaveInjectionDetails: "Échec de l'enregistrement des informations sur l'injection",
    diaryShockwaveAdded: "Ondes de choc ajoutées au journal",
    errorCreatingDiaryShockwave: "Erreur lors de la création des ondes de choc du journal",
    diaryShockwaveSaved: "Ondes de choc du journal enregistrées",
    shockwaveDetailsUpdated: "Informations sur les ondes de choc mises à jour",
    errorUpdatingShockwaveDetails: "Erreur lors de la mise à jour des informations sur les ondes de choc",
    shockwaveDiaryDefaultSaved: "Valeur par défaut du journal d'ondes de choc enregistrée",
    errorSavingShockwaveDiaryDefault:
        "Erreur lors de l'enregistrement de la valeur par défaut du journal d'ondes de choc",
    shockwaveDetailsRemoved: "Informations sur les ondes de choc supprimées",
    failedSaveShockwaveDetails: "Échec de l'enregistrement des informations sur les ondes de choc",
    scheduleUpdatedSuccess: "Calendrier mis à jour avec succès",
    failedUpdateSchedule: "Échec de la mise à jour du calendrier",
    scheduleDraftCreated: "Brouillon de calendrier créé",
    failedCreateScheduleFromDraft: "Échec de la création du calendrier à partir du brouillon",
    failedUpdatePublishStatus: "Échec de la mise à jour du statut de publication",
    formUpdated: "Formulaire mis à jour",
    failedUpdateForm: "Échec de la mise à jour du formulaire",
    formDraftCreated: "Brouillon de formulaire créé",
    failedCreateFormFromDraft: "Échec de la création du formulaire à partir du brouillon",
    pageSaved: "Page enregistrée",
    failedSavePage: "Échec de l'enregistrement de la page",
    pageDeleted: "Page supprimée",
    failedDeletePage: "Échec de la suppression de la page",
    questionSaved: "Question enregistrée",
    failedSaveQuestion: "Échec de l'enregistrement de la question",
    questionDeleted: "Question supprimée",
    failedDeleteQuestion: "Échec de la suppression de la question",
    patientAddedSuccess: "Patient ajouté avec succès !",
    emailWordsUpdatedSuccess: "Textes des e-mails mis à jour avec succès",
    failedUpdateEmailWords: "Échec de la mise à jour des textes des e-mails",
    emailSentSuccess: "E-mail envoyé avec succès",
    diaryAlreadyRead: "Journal déjà lu",
    noLastReadAction: "Aucune dernière action de lecture trouvée",
    actionComplete: (actionName) => `${actionName} terminé`,
    footLogCreatedSuccess: "Journal du pied créé avec succès",
    imageUploadedSuccess: "Image envoyée avec succès",
    imageLabelCreatedSuccess: "Étiquette d'image créée avec succès",
    qipPermissionsUpdated: "Autorisations QIP mises à jour avec succès",
    qipPermissionsUpdateFailed: "Échec de la mise à jour des autorisations QIP",
    riskAssessmentUpdateFailed: "Échec de la mise à jour de l'évaluation des risques",
    footCommentSubmitted: (comment) => `Vous avez envoyé le commentaire suivant :\n${comment}`,
    qrCodeNotReady: "Code QR pas encore prêt",
    qrCodeCopiedToClipboard: "Code QR copié dans le presse-papiers",
    couldNotCopyQrImage: "Impossible de copier l'image du code QR. Essayez plutôt une capture d'écran.",
    inviteSent: "Invitation envoyée",
    organisationRoleAddedSuccess: "Rôle d'organisation ajouté avec succès",
    errorAddingOrganisationRole: (message) => `Erreur lors de l'ajout du rôle d'organisation : ${message}`,
    organisationRoleUpdatedSuccess: "Rôle d'organisation mis à jour avec succès",
    errorUpdatingOrganisationRole: (message) => `Erreur lors de la mise à jour du rôle d'organisation : ${message}`,
    organisationRoleDeletedSuccess: "Rôle d'organisation supprimé avec succès",
    errorDeletingOrganisationRole: (message) => `Erreur lors de la suppression du rôle d'organisation : ${message}`,
    secretaryAddedToOrganisation: "Affectation de secrétaire ajoutée",
    errorAddingSecretaryToOrganisation: (message) =>
        `Erreur lors de l'ajout de l'affectation de secrétaire : ${message}`,
    defaultSecretarySet: "Personne de contact par défaut mise à jour",
    errorSettingDefaultSecretary: (message) =>
        `Erreur lors de la définition de la personne de contact par défaut : ${message}`,
    defaultSecretaryCleared: "Personne de contact par défaut supprimée",
    errorClearingDefaultSecretary: (message) =>
        `Erreur lors de la suppression de la personne de contact par défaut : ${message}`,
    secretaryRemovedFromOrganisation: "Affectation de secrétaire supprimée",
    errorRemovingSecretaryFromOrganisation: (message) =>
        `Erreur lors de la suppression de l'affectation de secrétaire : ${message}`,
    newOrganisationSaved: "Nouvelle organisation enregistrée",
    organizationCreatedSuccess: "Organisation créée avec succès !",
    audiencesUpdatedSuccess: "Audiences mises à jour avec succès",
    errorUpdatingAudiences: "Erreur lors de la mise à jour des audiences",
    labelAccessUpdated: "Accès par étiquette mis à jour",
    accessUpdated: "Accès mis à jour",
    photoUpdatedSuccess: "Photo mise à jour avec succès",
    failedUpdatePhoto: "Échec de la mise à jour de la photo",
    photoDeletedSuccess: "Photo supprimée avec succès",
    failedDeletePhoto: "Échec de la suppression de la photo",
    logoUpdatedSuccess: "Logo mis à jour avec succès",
    failedUpdateLogo: "Échec de la mise à jour du logo",
    logoDeletedSuccess: "Logo supprimé avec succès",
    failedDeleteLogo: "Échec de la suppression du logo",
    smsDisabledInKnock: "SMS désactivés dans Knock",
    failedUpdateKnockPreferences: "Échec de la mise à jour des préférences Knock",
    magicLinkGenerated: "Lien magique généré",
    errorImpersonatingUser: "Erreur lors de l'usurpation d'identité de l'utilisateur",
    fieldUpdatedSuccess: (field) => `${field} a été mis à jour avec succès.`,
    lockUnlockReasonRequired: (action) =>
        `Le motif ${action === "lock" ? "de validation" : "de déverrouillage"} est obligatoire`,
    lockUnlockSuccess: (action, count) => `${count} journaux ${action === "lock" ? "verrouillés" : "déverrouillés"}`,
    errorResolvedSuccess: "Erreur résolue avec succès",
    failedResolveError: (message) => `Échec de la résolution de l'erreur : ${message}`,
    healthCheckCompleted: (message) => `Contrôle de santé terminé : ${message}`,
    healthCheckFailed: (message) => `Échec du contrôle de santé : ${message}`,
    expectedCountUpdatedSuccess: "Nombre attendu mis à jour avec succès",
    failedUpdateExpectedCount: (message) => `Échec de la mise à jour du nombre attendu : ${message}`,
    fixedRecords: (fixed, failed) => `${fixed} enregistrements corrigés${failed ? `, ${failed} en échec` : ""}`,
    failedFixSharedAttributes: (message) => `Échec de la correction des attributs partagés : ${message}`,
    failedAssignRole: (message) => `Échec de l'attribution du rôle : ${message}`,
    failedLoadMessages: "Échec du chargement des messages",
    loggedInSuccess: "Connexion réussie",
    unknownLoginError: "Erreur de connexion inconnue",
    userDeleted: "Utilisateur supprimé",
    passwordSetSuccess: "Mot de passe défini avec succès !",
    emailVerificationSent: "E-mail de vérification envoyé",
    verificationCodeSent: "Code de vérification envoyé",
    verificationCodeSentEmail: "Code de vérification envoyé à votre adresse e-mail",
    failedSendVerificationCode: "Échec de l'envoi du code de vérification",
    emailVerificationFailed: "Échec de la vérification de l'e-mail",
    emailVerified: "E-mail vérifié",
    emailVerifiedShort: "E-mail vérifié !",
    invalidVerificationCode: "Code de vérification invalide",
    emailSetSuccess: "Adresse e-mail définie avec succès",
    emailSavedToProfileToast: "Adresse e-mail enregistrée dans votre profil",
    emailUpdatedSuccessToast: "Adresse e-mail mise à jour avec succès",
    superUserStatusUpdated: "Statut de super-utilisateur mis à jour",
    userInvited: "Utilisateur invité",
    profileAttributeLocked: "L'attribut du profil est verrouillé",
    addressAlreadyInUse: "Cette adresse est déjà utilisée.",
    mustBeSignedIn: "Vous devez être connecté(e).",
    contactPersonRequired: "La personne de contact est obligatoire.",
    somethingWentWrong: "Une erreur s'est produite. Veuillez réessayer.",
    resultsSentToEmail: "Résultats envoyés à votre adresse e-mail !",
    resultsEmailSendFailed:
        "Vos résultats sont prêts, mais nous n'avons pas pu envoyer l'e-mail. Veuillez réessayer plus tard.",
    fixHighlightedFieldsBeforeInvite: "Veuillez corriger les champs en surbrillance avant d'envoyer l'invitation.",
    pdfDownloaded: "PDF téléchargé",
    pdfDownloadFailed: "Échec du téléchargement du PDF",
    pdfGenerationFailed: "Échec de la génération du PDF",
    questionnaireResumed: "Questionnaire repris",
    errorResumingQuestionnaire: "Erreur lors de la reprise du questionnaire",
    trackerDeletedSuccess: "Suivi supprimé avec succès",
    diaryCreatedSuccess: "Journal créé avec succès",
    diaryDeletedSuccess: "Journal supprimé avec succès",
    templateSavedSuccess: "Modèle enregistré avec succès",
    failedSaveTemplate: "Échec de l'enregistrement du modèle",
    diaryAccessRemoved: "Accès au journal supprimé",
    failedRemoveDiaryAccess: "Échec de la suppression de l'accès au journal",
    entryRemindersTriggered: "Rappels de saisie déclenchés pour le suivi",
    correctionSaved: "Correction enregistrée",
    correctionReasonRequired: "Le motif de la correction est obligatoire",
    errorAddingPatient: "Erreur lors de l'ajout du patient, veuillez actualiser la page et réessayer.",
    invalidDate: "Date invalide",
    failedCreateDiary: (message) => `Échec de la création du journal : ${message}`,
    failedUpdateEntry: (message) => `Échec de la mise à jour de la saisie : ${message}`,
    failedDeleteSchedule: (message) => `Échec de la suppression du calendrier : ${message}`,
    failedCopySchedule: (message) => `Échec de la copie du calendrier : ${message}`,
    errorAddingUserToOrganisation: (message) => `Erreur lors de l'ajout de l'utilisateur à l'organisation : ${message}`,
    emailRequiredRefresh:
        "Nous avons besoin de votre adresse e-mail pour continuer. Veuillez actualiser la page et renvoyer le formulaire.",
    templateStillLoading: "Le modèle est encore en cours de chargement. Veuillez réessayer dans un instant.",
    phoneUpdatedSuccess: "Numéro de téléphone mis à jour avec succès",
    failedUpdatePhone: "Échec de la mise à jour du numéro de téléphone. Veuillez réessayer.",
    completeRequiredFields: (fieldsList) => `Veuillez compléter les champs obligatoires suivants :\n${fieldsList}`,
    missingEntry: "Saisie manquante",
    formSubmissionError: (message) => `Erreur lors de l'envoi du formulaire : ${message}`,
    organisationDeleted: "Organisation supprimée",
    noRowsToExport: "Aucune ligne à exporter sur cette page",
    exportedChangeEventsFromPage: (count) => `${count} événements de modification de cette page exportés`,
    noChangeEventsMatchFilters: "Aucun événement de modification ne correspond à ces filtres",
    exportedChangeEvents: (count) => `${count} événements de modification exportés`,
    mustSignInToExportSnapshot: "Vous devez être connecté(e) pour exporter un instantané",
    noDiariesToExport: "Aucun journal à exporter - ajustez d'abord la recherche ou les filtres",
    chooseSnapshotDateTime: "Choisissez une date et une heure de référence pour l'instantané",
    snapshotExported: (count, dateTime) =>
        count === 1
            ? `Instantané exporté pour 1 journal à la date du ${dateTime} UTC`
            : `Instantané exporté pour ${count} journaux à la date du ${dateTime} UTC`,
    snapshotExportFailed: "Échec de l'export de l'instantané",
    exportFailed: "Échec de l'export",
    exportedChangeEventsTruncated: (exported, total) =>
        `Export des ${exported} premiers événements de modification sur ${total} correspondants (limite de 10 000 lignes)`,
    printing: "Impression",
    failedGeneratePrintUrl: "Échec de la génération de l'URL d'impression",
    reportPrintQueued:
        "Rapport mis en file d'attente. Il sera généré sur le serveur sous peu - réessayez d'imprimer dans quelques minutes.",
    reportPrintRendering: "Génération de votre rapport...",
    reportPrintRefreshing: "Journal mis à jour - génération d'un nouveau rapport...",
    reportPrintPreparing: "Préparation de votre rapport...",
    reportPrintTimeout:
        "La génération du rapport prend plus de temps que prévu. Veuillez réessayer d'imprimer dans quelques minutes.",
    unknownError: "Erreur inconnue",
    failedCreateOrganisation: "Échec de la création de l'organisation",
    correctionFailed: "Échec de la correction",
    couldNotSaveProcedureDate: "Impossible d'enregistrer la date de votre intervention",
    couldNotSave: "Impossible d'enregistrer",
    invalidFieldSelection:
        "Un ou plusieurs champs comportent une sélection invalide - veuillez vérifier le formulaire et réessayer.",
    completeAllRequiredFieldsBeforeSaving: "Veuillez compléter tous les champs obligatoires avant d'enregistrer.",
    detailsAlreadySaved: "Ces informations ont déjà été enregistrées.",
    unableToSaveInjectionDetails:
        "Impossible d'enregistrer les informations sur l'injection. Veuillez vérifier vos saisies et réessayer.",
    unableToSaveShockwaveDetails:
        "Impossible d'enregistrer les informations sur les ondes de choc. Veuillez vérifier vos saisies et réessayer.",
    invitationLinkExpired:
        "Ce lien d'invitation a expiré. Saisissez votre adresse e-mail pour obtenir un nouveau code.",
    invitationLinkInvalid:
        "Ce lien est invalide ou a expiré. Saisissez votre adresse e-mail pour obtenir un nouveau code.",
    confirmAccountCouldNotTextTryEmail:
        "Nous n'avons pas pu envoyer de SMS à ce numéro. Essayez avec l'adresse e-mail de votre invitation si vous en avez une.",
    confirmAccountNoAccountForDetails:
        "Nous n'avons trouvé aucun compte correspondant à ces informations. Veuillez vérifier ou vous adresser à l'équipe qui vous a invité(e) si vous avez besoin d'aide.",
    smsVerificationUnavailableForNumber:
        "La vérification par SMS n'est pas encore disponible pour ce numéro. Utilisez l'adresse e-mail de votre invitation, ou adressez-vous à l'équipe qui vous a invité(e).",
    smsVerificationTextFailedSignup:
        "Nous n'avons pas pu envoyer de SMS de vérification à ce numéro. Si vous avez un compte, essayez de vous connecter avec votre adresse e-mail, ou demandez de l'aide à l'équipe qui vous a invité(e).",
    smsSignInNotEnabledForProject:
        "La connexion par SMS n'est pas activée pour ce projet. L'équipe qui vous a invité(e) ou l'assistance peut vous aider.",
    smsCouldNotSendCheckNumber:
        "Nous n'avons pas pu envoyer de SMS à ce numéro. Vérifiez le numéro, essayez la connexion par e-mail, ou adressez-vous à l'équipe qui vous a invité(e).",
    smsLoginTextFailedOtpDisabled:
        "Nous avons trouvé votre compte, mais n'avons pas pu envoyer de SMS de connexion. Connectez-vous avec votre e-mail et votre mot de passe, ou adressez-vous à l'équipe qui vous a invité(e) si vous avez besoin d'aide.",
    smsLoginTextFailedAccountFound:
        "Nous avons trouvé votre compte, mais n'avons pas pu envoyer de SMS de connexion à ce numéro. Connectez-vous avec votre e-mail, ou adressez-vous à l'équipe qui vous a invité(e) si vous avez besoin d'aide pour les SMS.",
    clinicianUpdateFailedDescription: "Échec de la mise à jour du clinicien. Veuillez réessayer.",
    lockUnlockPartialFailure: (action, succeeded, failed, failedNames, firstError) =>
        `${succeeded} ${action === "lock" ? "verrouillés" : "déverrouillés"}, ${failed} en échec : ${failedNames} (${firstError})`,
    rolesAssignedToUsers: (role, assigned, failed) =>
        `Rôle ${role} attribué à ${assigned} utilisateurs${failed ? `, ${failed} en échec` : ""}`,
    pdfDownloadFailedDescription: "Échec du téléchargement du PDF généré",
    pdfGenerationFailedDescription: "Échec de la génération du PDF",
    pdfDownloadSuccessDescription: "Votre PDF a bien été téléchargé.",
};
